<script setup>
import Welcome from '@/components/welcome/Welcome.vue';
import LoginForm from '@/components/auth/LoginForm.vue';
import { useRouter } from 'vue-router';
import { watch } from 'vue';
import { useAuthStore } from '@/stores/auth.js';
const router = useRouter();
const auth = useAuthStore();
watch(
  () => auth.user,
  (newUser) => {
    if (newUser) {
      router.push('/todo');
    }
  },
  { immediate: true },
); // ログイン済みの場合todo画面へ飛ばす
</script>
<template>
  <!-- ログイン画面 -->
  <p class="mb-7"></p>
  <LoginForm />

  <!-- Welcomeページ -->
  <Welcome />
</template>
